import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography, web_max_width } from '@common/styles';

import { ScrollGuideIcon } from './ScrollGuideIcon';

interface Props {
  bottom?: number;
}

export const ScrollGuide = ({ bottom = 0 }: Props) => {
  return (
    <Container bottom={bottom}>
      <ScrollGuideIcon />
      <p className={Typography.BODY_16_SEMIBOLD}>더 많은 상품을 확인해 보세요</p>
    </Container>
  );
};

const Container = styled.div<{ bottom: number }>`
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: ${web_max_width}px;
  height: 136px;
  background: linear-gradient(180deg, rgba(100, 100, 100, 0) 0%, rgba(0, 0, 0, 0.9) 100%);
  position: fixed;
  bottom: ${({ bottom }) => `${bottom}px`};
  z-index: 100;
  color: ${vars.v3Color.staticWhite};
`;
